import { Button, Modal } from 'react-bootstrap';
import React from 'react';
import { Box } from '@material-ui/core';
const ModalPopup = ({
  open,
  handleClose,
  title,
  children,
  size = 'md',
  onSave = () => {
    console.log('onsave');
  },
  saveText = 'Save',
  cancelText = 'Cancel',
  showFooter = true,
  showCross = true
}) => {
  return (
    <Modal
      show={open}
      onHide={handleClose}
      size={size}
      keyboard={false}
      //   id=""
      scrollable
      dialogClassName="createReportModal"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ background: 'var(--primary)', color: 'white' }}>
        <Modal.Title>{title}</Modal.Title>
        {showCross && (
          <Button
            variant={'white'}
            size="sm"
            style={{
              fontSize: '0.65rem'
            }}
            onClick={handleClose}
          >
            <i
              className="uil uil-times cross-icon"
              style={{
                fontSize: '18px'
              }}
            ></i>
          </Button>
        )}
      </Modal.Header>

      <Modal.Body className="create-report-modal-body">
        <Box p={2}>{children ? children : null}</Box>
      </Modal.Body>
      {showFooter && (
        <Modal.Footer className="create-report-modal-footer">
          <Button
            //   disabled={loading || runLoading}
            type="button"
            variant="primary"
            size="md"
            className=" btn-flex btn-md float-right ml-2"
            // onClick={reportFormIk.handleSubmit}
            onClick={handleClose}
          >
            <span>{cancelText}</span>
          </Button>
          <Button
            // disabled={loading }
            type="button"
            variant="primary"
            className=" btn-md btn-flex float-right"
            onClick={onSave}
          >
            <span>{saveText}</span>
            {/* {loading && <i className="uil uil-spinner spinner ml-2"></i>} */}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalPopup;
